import React from 'react';
import PropTypes from 'prop-types';
import { Configure, Index, useHits, useInstantSearch } from 'react-instantsearch';
import { Column, Row } from '@pella/sash-framework';
import * as HitLink from '../../../../page/search/hit-comps';

import './index.css';

const CareersResults = ({ indices }) => {
	const { hits, results } = useHits();
	const { indexUiState } = useInstantSearch();

	if (!indexUiState?.query || results.nbHits === 0) return null;

	return (
		<div className={`careersResults max-sm:bottom-full sm:absolute sm:z-[11] sm:border-primary sm:bg-white sm:max-lg:left-5 sm:max-lg:right-5 sm:max-lg:top-full sm:max-lg:max-h-[calc(100vh-100px)] sm:max-lg:overflow-auto sm:max-lg:border-2 sm:max-lg:p-5 sm:max-lg:shadow-md lg:relative lg:border-0 lg:max-2xl:mt-6 2xl:absolute 2xl:right-10 2xl:top-[calc(100%-3px)] 2xl:max-h-[calc(100vh-100px)] 2xl:w-[750px] 2xl:overflow-auto 2xl:border-2 2xl:p-6`}>
			<Configure
				snippetEllipsisText='...'
				clickAnalytics={true}
			/>

			<Row className='lg:-mx-7 lg:[&>*]:px-7'>
				{indices.map(({ name, title }) => (
					<Column
						key={name}
						xs={12}
						lg='fluid'
					>
						<Index indexName={name}>
							<div className='careersResults-hits'>
								<p className='mb-2 mt-4 text-sm uppercase tracking-wider text-neutral-600 sm:mt-0'>
									<span>{title}</span>
									<span className='ml-1'>({results.nbHits})</span>
								</p>

								<div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
									{hits.map((hit, index) => (
										<HitLink.NoImageHitLink
											hit={hit}
											key={index}
										/>
									))}
								</div>
							</div>
						</Index>
					</Column>
				))}
			</Row>
		</div>
	);
};

CareersResults.propTypes = {
	indices: PropTypes.array.isRequired,
};

export default CareersResults;
